import * as React from 'react';
import { useIntl } from 'react-intl';

import {
  DrawerContext,
  IconRegularClose,
  ReactFCC,
} from '@notino/react-styleguide';
import { IIconProps } from '@notino/react-styleguide/dist/types/components/atoms/Icons/utils/model';

import { sortFilterBarMessages } from '../../messages';

import {
  DrawerTitleContainer,
  DrawerIconWrapper,
  DrawerDragger,
  StyledDrawerTitle,
  DrawerTitleWrapper,
  CloseIconButton,
} from './styled';

export interface IDrawerTitleProps {
  name: React.ReactNode;
  titleIcon?: ReactFCC<IIconProps>;
  /** Lets the option group inside the drawer reference the title as its label. */
  id?: string;
}

export const DrawerTitle = ({
  name,
  id,
  titleIcon: CloseIconElement = IconRegularClose,
}: IDrawerTitleProps) => {
  const { closeDrawer } = DrawerContext.useDrawerContext();
  const { formatMessage } = useIntl();

  return (
    <DrawerTitleContainer>
      <DrawerIconWrapper>
        <DrawerDragger />
      </DrawerIconWrapper>
      <DrawerTitleWrapper>
        <StyledDrawerTitle id={id}>{name}</StyledDrawerTitle>

        <CloseIconButton
          type="button"
          aria-label={formatMessage(sortFilterBarMessages.closeDrawer)}
          onClick={() => {
            closeDrawer();
          }}
        >
          <CloseIconElement
            color="icon.primary"
            width="1.25rem"
            height="1.25rem"
          />
        </CloseIconButton>
      </DrawerTitleWrapper>
    </DrawerTitleContainer>
  );
};
